import { useState } from 'react';
import type { MigratedPlotFormProps } from '../../../../forms/formHandlerShared';
import {
  getName,
  isValid,
  setName,
} from '../../../../state/dashboard-element-operations';
import { EntityScopeSelector } from '../shared/EntityScopeSelector';
import {
  PlotConfigFormDivider,
  PlotConfigFormShell,
  PlotConfigNameField,
  PlotConfigSubmitButton,
} from '../shared/plotConfigFormLayout';

function ImageGalleryForm({
  config,
  onSubmit,
  onChange,
}: MigratedPlotFormProps) {
  const [submitCount, setSubmitCount] = useState(0);
  const [isSending, setIsSending] = useState(false);
  const [validation, setValidation] = useState(isValid(config));

  const handleNameChange = (name: string) => {
    const newConfig = setName(name, config);
    setValidation(isValid(newConfig));
    onChange(newConfig);
  };

  const handleEntityScopeChange = (newConfig: typeof config) => {
    setValidation(isValid(newConfig));
    onChange(newConfig);
  };

  const handleSubmit: React.FormEventHandler = (e) => {
    e.preventDefault();
    setSubmitCount(submitCount + 1);
    if (validation[0]) {
      setIsSending(true);
      onSubmit(config).finally(() => setIsSending(false));
    }
  };

  return (
    <PlotConfigFormShell onSubmit={handleSubmit}>
      <PlotConfigNameField
        value={getName(config)}
        onChange={handleNameChange}
        errors={validation[1].name ?? []}
        submitted={submitCount > 0}
        required
      />

      <PlotConfigFormDivider />

      <EntityScopeSelector
        widget="image_gallery"
        config={config}
        onChange={handleEntityScopeChange}
        title="Portée de la galerie"
      />

      <PlotConfigSubmitButton isSending={isSending} />
    </PlotConfigFormShell>
  );
}

export default ImageGalleryForm;
